import z from "zod"
import { EnergyType } from "../types/energyType"

export const SelectedEnergyTypesSchema = z.union([
    z.tuple([z.enum(EnergyType)]),
    z.tuple([z.literal(EnergyType.Electricity), z.literal(EnergyType.Gas)]),
])
